import { ReactNode } from "react";

import { Typo } from "../../../Typo";
import { formatUSDWithoutSymbol } from "../utils/formatters";

type ChartCardDataProp = {
  title: string;
  subtitle?: string;
  modalTitle?: string;
  info?: string;
  showMore?: boolean;
  total?: number;
  totalCurrencyCode?: string;
  toggle?: ReactNode;
  isMobile?: boolean;
  chart: ReactNode;
};

export const ChartSectionEntry = ({
  title,
  subtitle,
  isMobile,
  total,
  chart,
  totalCurrencyCode,
  toggle,
}: ChartCardDataProp) => {
  return (
    <div className="flex min-h-[422px] flex-col rounded-xl">
      <div className="flex h-full w-full flex-col gap-4 rounded-xl bg-surface-brand-subtle p-6 md:p-8">
        <div className="flex flex-col-reverse justify-stretch gap-4 md:flex-row md:items-start md:justify-between">
          <div className="flex flex-col items-start gap-2">
            <div className="flex flex-row items-center">
              <Typo type="labelMD">{title}</Typo>
            </div>
            {subtitle && (
              <div className="font-normal text-text-tertiary">
                <Typo type="bodySM" textColor="text-text-tertiary">
                  {subtitle}
                </Typo>
              </div>
            )}
            {total != null && (
              <div className="flex flex-row items-end gap-2">
                <Typo
                  element="h4"
                  type={isMobile ? "headingLG" : "heading3XL"}
                  textColor="text-text-primary"
                >
                  {formatUSDWithoutSymbol(total)}
                </Typo>
                <Typo
                  element="p"
                  type="labelSM"
                  textColor="text-text-secondary"
                  classes={isMobile ? "" : "mb-1"}
                >
                  {totalCurrencyCode}
                </Typo>
              </div>
            )}
          </div>
          {toggle}
        </div>
        <div className="flex flex-1 flex-col">{chart}</div>
      </div>
    </div>
  );
};
